import { render, staticRenderFns } from "./RegisterUSDT.vue?vue&type=template&id=19e71622&"
import script from "./RegisterUSDT.vue?vue&type=script&lang=js&"
export * from "./RegisterUSDT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports